import { chainIdToDomain, getAlchemyRpcUrl, getDrpcRpcUrl } from '@sparkdotfi/common-universal'
import { fromKeys } from 'remeda'
import { fallback, http, Transport } from 'viem'
import { arbitrum, avalanche, base, gnosis, mainnet, optimism, unichain } from 'viem/chains'

import { getInjectedNetwork } from './getInjectedNetwork'

export type GetTransportsResult = Record<number, Transport>

export function getTransports(): GetTransportsResult {
  const supportedChainIds = [
    mainnet.id,
    gnosis.id,
    base.id,
    arbitrum.id,
    optimism.id,
    unichain.id,
    avalanche.id,
  ] as const

  const transports: Record<number, Transport> = fromKeys(supportedChainIds, (chainId): Transport => {
    return fallback([
      http(getDrpcRpcUrl({ domain: chainIdToDomain[chainId], drpcApiKey: import.meta.env.VITE_DRPC_API_KEY })),
      http(getAlchemyRpcUrl({ domain: chainIdToDomain[chainId], alchemyApiKey: import.meta.env.VITE_ALCHEMY_API_KEY })),
    ])
  })

  if (import.meta.env.VITE_FEATURE_RPC_INJECTION_VIA_URL === '1') {
    const injectedNetwork = getInjectedNetwork()
    if (injectedNetwork) {
      transports[injectedNetwork.chainId] = http(injectedNetwork.rpc)
    }
  }

  return transports
}
